/**
 * Created by lobin on 2019/1/21.
 */
import Vue from "vue";
import Vuex from "vuex";
import vuexLoading from "../libs/vuex-loading";
import { request } from "../plugins/axios";

Vue.use(Vuex);
import user from "./modules/user";
import dictionary from "./modules/dictionary";
import jobs from "./modules/jobs";
import resume from "./modules/resume";
import company from "./modules/company";
import homePage from "./modules/homePage";
import about from './modules/about'

function getBasesicDataByCode(state, code) {
  let result = [];
  state.dictionaries.map(item => {
    if (item.code === code) {
      result = item.children;
      // item.children.map(i => {
      // 	result.push({
      //    code:i.code + '',
      //    name:i.name,
      // 	})
      // })
    }
  });
  return result;
}

export default new Vuex.Store({
  plugins: [vuexLoading],
  modules: {
    user,
    dictionary,
    jobs,
    resume,
    company,
    homePage,
    about
  },
  state: {
    attachmentsUrl: `${process.env.VUE_APP_APIBASEURL}/portal/attachments/image`,
    uploadResume: `${process.env.VUE_APP_APIBASEURL}/portal/resume/RESUME/1`,
    uploadAttachementResume: `${process.env.VUE_APP_APIBASEURL}/portal/resume/online/1`,
    baseUrl: process.env.VUE_APP_APIBASEURL,
    token: window.localStorage.getItem("token"),
    dictionaries: []
  },
  mutations: {
    comState(state, { key, data }) {
      state[key] = data;
    }
  },
  getters: {
    companyType(state) {
      return getBasesicDataByCode(state, 101);
    },
    financingType(state) {
      return getBasesicDataByCode(state, 102);
    },
    positionType(state) {
      return getBasesicDataByCode(state, 103);
    },
    qualificationsType(state) {
      return getBasesicDataByCode(state, 104);
    },
    workExperienceType(state) {
      return getBasesicDataByCode(state, 105);
    },
    industryType(state) {
      return getBasesicDataByCode(state, 106);
    },
    scale(state) {
      return getBasesicDataByCode(state, 107);
    },
    salaryRange(state) {
      return getBasesicDataByCode(state, 108);
    },
    feedbackType(state) {
      return getBasesicDataByCode(state, 109);
    },
    specialPerformanceType(state) {
      return getBasesicDataByCode(state, 110);
    },
    currentState(state) {
      return getBasesicDataByCode(state, 111);
    },
    gender(state) {
      return getBasesicDataByCode(state, 113);
    },
    maritalStatus(state) {
      return getBasesicDataByCode(state, 115);
    },
    schoolType(state) {
      return getBasesicDataByCode(state, 114);
    },
    seekerCurrentState(state) {
      return getBasesicDataByCode(state, 117);
    },
    operatingState(state) {
      return getBasesicDataByCode(state, 118);
    },
    reason(state) {
      return getBasesicDataByCode(state, 120);
    },
    invoiceType(state) {
      return getBasesicDataByCode(state, 131);
    },
    goodsNameType(state) {
      return getBasesicDataByCode(state, 130);
    }
  },
  actions: {
    /**
     * 获取字典信息
     */
    async getDictionaries({ commit }) {
      const { data } = await request({
        url: "/portal/dictionaries"
      });
      commit("comState", {
        key: "dictionaries",
        data
      });
      return true;
    },
    async feedBack({}, content) {
      return request({
        url: "/portal/feedback",
        method: "post",
        data: {
          content,
          source: "1"
        }
      });
    },
    /**
     * 初始化数据
     */
    async getInitDate({ dispatch }) {
      const userInfo = dispatch("getSelfUserInfo");
      // const dic = dispatch("getScreeningConditions");
      const dic2 = dispatch("getDictionaries");
      return await Promise.all([userInfo, dic2]);
      // return await Promise.all([userInfo,dic, dic2]);
    }
  }
});
